export const MIN_POSSIBLE_VALUES_INPUTS_COUNT = 5;

export const DEFAULT_ATTRIBUTE_DETAIL = {
    attributeId: '',
    name: '',
    description: '',
    fieldType: '',
    itemsType: '',
    required: false,
    deprecated: false,
    possibleValues: [],
    lastUsageDate: '',
};

export const ColumnWidth = {
    required: '6rem',
    attribute: '15rem',
    dataType: '13rem',
    description: 'calc(80% - 53em)',
    possibleValues: '15%',
    button: '1.5rem',
    deprecated: '8rem',
    lastUsageDate: '11rem',
};
